import { createFileRoute } from '@tanstack/react-router';
import { AuthGate } from '@/components/AuthGate';
import { AppShell } from '@/components/layout/AppShell';
import { ChatView } from '@/features/chat/ChatView';
import { useAmbientIdentity } from '@/features/ambient/useAmbientIdentity';

/**
 * `/lucid` — Quon の "ホーム" (Self = Ambient とのチャット)。
 *
 * Spec #171 Phase 2: Lucid (scene / UISpec) を廃止し「普通のチャット」
 * (`features/chat/ChatView`) に差し替えた (決定 D1、提案者: 凜さん
 * 2026-07-02)。URL は既存ナビ (Sidebar / index redirect) との互換のため
 * `/lucid` のまま据え置く。
 *
 * Composition:
 *   AuthGate → AppShell → ChatView (thread: self)
 *
 *   - AuthGate: 未認証は `/signin` に遷移、認証中は fallback (空) を返す。
 *   - AppShell: contact-list サイドバー (Agents) を提供。
 *   - ChatView self: 履歴 GET + SSE 送受信。
 *     (旧 Lucid localStorage 履歴の一回限りインポートは移行ウィンドウ終了で
 *     撤去 — 簡素化ミッション R2 PR-5、提案者: 凜さん 2026-07-05)
 */
function SelfChatPage() {
  // self スレッドの threadId = 自分の user id (chat_messages RLS と一致)。
  const userId = useAmbientIdentity();
  return (
    <AppShell>
      {userId ? (
        <ChatView thread={{ kind: 'self', userId }} />
      ) : (
        // identity 解決待ち (瞬間的)。チラつき防止で空を出す。
        <div className="h-full" data-testid="chat-self-identity-pending" />
      )}
    </AppShell>
  );
}

function GatedSelfChat() {
  return (
    <AuthGate fallback={<div className="p-6 text-sm text-muted-foreground">loading…</div>}>
      <SelfChatPage />
    </AuthGate>
  );
}

export const Route = createFileRoute('/lucid')({
  component: GatedSelfChat,
});
